import React from 'react';
import Meta from '../components/Meta';
import PipelineSection from '../components/PipelineSection';
import { requireAuth } from '../util/auth';

function PipelinePage() {
  return (
    <>
      <Meta title="Pipeline" />
      <PipelineSection />
    </>
  );
}

export default requireAuth(PipelinePage);
